import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Grid,
  Box,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  MenuItem,
  IconButton,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import {
  CustomStyledButtonSolid,
  StyledAutocomplete,
  StyledSelect,
  StyledTextFieldBootstrap,
} from "../../doctor-console/StyledComponents";
import sleepMedicineIcon from "../../../../src/assets/images/icons/sleep.png";
import painManagementIcon from "../../../../src/assets/images/icons/muscle-spasm.png";
import palliativeCareIcon from "../../../../src/assets/images/icons/social-care.png";
import internalMedicineIcon from "../../../../src/assets/images/icons/take-medicines.png";
import familyMedicineIcon from "../../../../src/assets/images/icons/medical.png";
import neonatologyIcon from "../../../../src/assets/images/icons/baby.png";
import cardiothoracicSurgeryIcon from "../../../../src/assets/images/icons/heart.png";
import vascularSurgeryIcon from "../../../../src/assets/images/icons/surgery.png";
import plasticSurgeryIcon from "../../../../src/assets/images/icons/reconstructive.png";
import entIcon from "../../../../src/assets/images/icons/head.png"; // Otolaryngology (ENT)
import anesthesiologyIcon from "../../../../src/assets/images/icons/anesthesiology.png";
import geriatricsIcon from "../../../../src/assets/images/icons/geriatrics.png";
import physicalMedicineIcon from "../../../../src/assets/images/icons/medicine2.png";
import allergyImmunologyIcon from "../../../../src/assets/images/icons/allergy.png";
import infectiousDiseasesIcon from "../../../../src/assets/images/icons/coronavirus.png";
import rheumatologyIcon from "../../../../src/assets/images/icons/rheumatology.png";
import hematologyIcon from "../../../../src/assets/images/icons/blood-drop.png";
import radiologyIcon from "../../../../src/assets/images/icons/radiology.png";
import urologyIcon from "../../../../src/assets/images/icons/urology.png";
import orthopaedicsIcon from "../../../../src/assets/images/icons/trabecular.png";
import pulmonologyIcon from "../../../../src/assets/images/icons/pulmonology.png";
import emergencyMedicinesIcon from "../../../../src/assets/images/icons/medicine.png";
import nephrologyIcon from "../../../../src/assets/images/icons/nephrology.png";
import psychiatryIcon from "../../../../src/assets/images/icons/psychiatry.png";
import gynecologyIcon from "../../../../src/assets/images/icons/gynecology.png";
import dermatologyIcon from "../../../../src/assets/images/icons/dermatology.png";
import oncologyIcon from "../../../../src/assets/images/icons/oncology.png";
import neurologyIcon from "../../../../src/assets/images/icons/neuron.png";
import gastroenterologyIcon from "../../../../src/assets/images/icons/stomach.png";
import cardiologyIcon from "../../../../src/assets/images/icons/medical-checkup.png";
import endocrinologyIcon from "../../../../src/assets/images/icons/endocrinology.png";
import paediatricsIcon from "../../../../src/assets/images/icons/healthcare.png";
import ophthalmologyIcon from "../../../../src/assets/images/icons/vision-care.png";
import dentistryIcon from "../../../../src/assets/images/icons/dental-checkup.png";
import generalPracticeIcon from "../../../../src/assets/images/icons/doctors-office.png";
import hepatologyIcon from "../../../../src/assets/images/icons/hepatology.png";
import nutritionIcon from "../../../../src/assets/images/icons/nutrition.png";

import { ReactComponent as DELETEIcon } from "./DELETEIcon.svg";
import { ReactComponent as EDITIcon } from "./EDITIcon.svg";

import "./DepartmentManagement.scss"; // Import the new SCSS file

function DepartmentManagement() {
  const [departments, setDepartments] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") || ""
  );
  const [formType, setFormType] = useState("select");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [newDepartment, setNewDepartment] = useState("");
  const [newDepartmentIcon, setNewDepartmentIcon] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [departmentToEdit, setDepartmentToEdit] = useState(null);
  const [medicalDepts, setMedicalDepts] = useState([]);
  const [predefinedDepts, setPredefinedDepts] = useState([]);
  const fileInputRef = useRef(null);

  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

  const fetchBrandingData = () => {
    const payload = {
      // functionality: "branding",
      // segment: "departments",
      // config_type: "departments",
      bucket_type: "tenant",
      bucket_category: "dept",
      file_key: "",
      facility: true,
      facility_id: sessionStorage.getItem("facility_name"),
    };

    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}get_facility_branding/`, payload, {
        headers: {
          ...headers,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.status === "Success") {
          setMedicalDepts(res.data?.data); // Save the branding map
          console.log("Branding data fetched successfully:", res.data?.data);
        } else if (res?.data?.message === "No files found.") {
          toast.info("Branding information not yet provided");
        } else {
          // toast.error("Error fetching branding data");
          console.log("Error:", res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    fetchBrandingData();
  }, []);
  console.log("medical depts", medicalDepts);
  const getAllDepartments = () => {
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`, {
        headers,
      })
      .then((res) => {
        if (res.data.status == "Success") {
          const departmentsData = res.data.department_list.map(
            (dept, index) => ({
              id: index + 1,
              department: dept.department,
              department_id: dept.department_id,
            })
          );
          setDepartments(departmentsData);
        } else {
          console.log("error in getting the department ");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAllPredefinedDepartments = () => {
    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}get_department_list/`, {
        headers,
      })
      .then((res) => {
        if (res.data.status == "Success") {
          const departmentsData = res.data.data
            .filter((dept) => dept.is_preloaded === true)
            .map((dept, index) => ({
              id: dept.id,
              name: dept.name,
              department_id: dept.department_id,
              // icon: `/assets/icon_images/General Practice.png`,
            }));
          setPredefinedDepts(departmentsData);
        } else {
          console.log("error in getting the department ");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getAllDepartments();
    getAllPredefinedDepartments();
  }, []);

  const handleDepartmentChange = (event) =>
    setSelectedDepartment(event.target.value);
  const handleNewDepartmentChange = (event) =>
    setNewDepartment(event.target.value);
  const handleIconChange = (event) => {
    console.log("icon-->", event.target.files[0]);
    setNewDepartmentIcon(event.target.files[0]);
  };
  const handleFormTypeChange = (event) => setFormType(event.target.value);

  const addDepartmentToFacility = () => {
    if (formType === "add" && !newDepartmentIcon) {
      toast.error("Please upload an icon for the new department.");
      return;
    }
    if (formType === "add" && newDepartment.length === 0) {
      toast.error("Please add a new department name.");
      return;
    }
    if (formType === "select" && selectedDepartment.length === 0) {
      toast.error("Please select a department.");
      return;
    }
    if (newDepartmentIcon) {
      const fileSizeInKB = newDepartmentIcon.size / 1024; // Convert size to KB
      if (fileSizeInKB < 20 || fileSizeInKB > 10240) {
        toast.error("File size must be between 20KB and 10MB");
        return;
      }
    }
    const payload = {
      department: formType === "add" ? newDepartment : selectedDepartment,
      new_department: true,
    };

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}add_update_medical_departments/`,
        payload,
        {
          headers: {
            ...headers,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.status == "Success") {
          // Only call save_facility_branding if formType is "add"
          if (formType === "add" && newDepartmentIcon) {
            const formData = new FormData();
            // formData.append("functionality", "branding");
            // formData.append("segment", "departments");
            formData.append("bucket_type", "tenant");
            formData.append("bucket_category", "dept");
            // formData.append("config_type", "departments");
            formData.append("facility", true);
            // Rename and append the file
            const renamedFile = new File(
              [newDepartmentIcon],
              `${newDepartment}.png`,
              { type: newDepartmentIcon.type }
            );
            formData.append("file_object", renamedFile);

            // Save branding
            axios
              .post(
                `${REACT_APP_BACKEND_ROUTE_URL}save_facility_branding/`,
                formData,
                {
                  headers: {
                    ...headers,
                    "Content-Type": "multipart/form-data",
                  },
                }
              )
              .then((brandingRes) => {
                if (brandingRes.data.status === "Success") {
                  toast.success("Department and branding saved successfully!");
                  resetForm();
                  getAllDepartments();
                  fetchBrandingData();
                } else {
                  const message =
                    brandingRes.data.message || "An unknown error occurred.";
                  if (message.includes("corrupted")) {
                    toast.error(
                      "The Facility documents uploaded are corrupted. Please try with a different document."
                    );
                  } else if (message.includes("Virus")) {
                    toast.error(
                      "The Facility documents uploaded has virus. Please try with a different document."
                    );
                  } else {
                    toast.error(message);
                  }
                  // toast.error(
                  //   brandingRes.data.message || "Error saving branding"
                  // );
                }
              })
              .catch((brandingErr) => {
                console.log(brandingErr);
                toast.error("Error saving branding");
              });
          } else {
            // Just reset the form if not adding a new department
            toast.success("Department added successfully!");
            resetForm();
            getAllDepartments();
          }
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error adding department");
      });
  };

  const updateDepartment = () => {
    if (newDepartmentIcon) {
      const fileSizeInKB = newDepartmentIcon.size / 1024; // Convert size to KB
      if (fileSizeInKB < 20 || fileSizeInKB > 10240) {
        toast.error("File size must be between 20KB and 10MB");
        return;
      }
    }

    if (newDepartment.length === 0 && selectedDepartment.length === 0) {
      toast.error("Please add a department name.");
      return;
    }

    const payload = {
      department: departmentToEdit.department,
      updated_department: newDepartment,
      new_department: false,
    };

    if (newDepartmentIcon) {
      payload.icon = newDepartmentIcon;
    }

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}add_update_medical_departments/`,
        payload,
        {
          headers: {
            ...headers,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.status === "Success") {
          // Only call save_facility_branding if formType is "add"
          if (formType === "select" && newDepartmentIcon) {
            const formData = new FormData();
            // formData.append("functionality", "branding");
            // formData.append("segment", "departments");
            // formData.append("config_type", "departments");
            formData.append("bucket_type", "tenant");
            formData.append("bucket_category", "dept");
            formData.append("facility", true);
            // Rename and append the file
            const renamedFile = new File(
              [newDepartmentIcon],
              `${newDepartment}.png`,
              { type: newDepartmentIcon.type }
            );
            formData.append("file_object", renamedFile);

            // Save branding
            axios
              .post(
                `${REACT_APP_BACKEND_ROUTE_URL}save_facility_branding/`,
                formData,
                {
                  headers: {
                    ...headers,
                    "Content-Type": "multipart/form-data",
                  },
                }
              )
              .then((brandingRes) => {
                if (brandingRes.data.status === "Success") {
                  toast.success(res.data.message);
                  resetForm();
                  getAllDepartments();
                  fetchBrandingData();
                } else {
                  const message =
                    brandingRes.data.message || "An unknown error occurred.";
                  if (message.includes("corrupted")) {
                    toast.error(
                      "The Facility documents uploaded are corrupted. Please try with a different document."
                    );
                  } else if (message.includes("Virus")) {
                    toast.error(
                      "The Facility documents uploaded has virus. Please try with a different document."
                    );
                  } else {
                    toast.error(message);
                  }
                  // toast.error(
                  //   brandingRes.data.message || "Error saving branding"
                  // );
                }
              })
              .catch((brandingErr) => {
                console.log(brandingErr);
                toast.error("Error saving branding");
              });
          } else {
            // Just reset the form if not adding a new department
            toast.success(res.data.message);
            resetForm();
            getAllDepartments();
          }

          // resetForm();
          // getAllDepartments();
          // toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error updating department");
      });
  };

  const handleDeleteDepartment = (deptId) => {
    if (window.confirm("Are you sure you want to delete the department?")) {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}delete_medical_departments/`,
          { department_ids: [deptId] },
          { headers }
        )
        .then((res) => {
          getAllDepartments();
          fetchBrandingData();
          toast.success("Department deleted");
        })
        .catch((err) => {
          console.log(err);
          toast.error("Error deleting department");
        });
    }
  };

  // const handleEditDepartment = (department) => {
  //   setDepartmentToEdit(department);
  //   setNewDepartment(department.department);
  //   setEditMode(true);
  //   const matchedDept = medicalDepts?.find(
  //     (dept) => dept.name.trim() === department.department.trim()
  //   );
  //   const content = matchedDept ? matchedDept.content : null;
  //   setNewDepartmentIcon(content);
  // };

  // const handleEditDepartment = (department) => {
  //   setDepartmentToEdit(department);
  //   setNewDepartment(department.department);
  //   setEditMode(true);

  //   const matchedDept = medicalDepts?.find(
  //     (dept) => dept.name.trim() === department.department.trim()
  //   );

  //   const base64 = matchedDept?.content;

  //   if (base64) {
  //     // Extract content type and base64 data
  //     const arr = base64.split(",");
  //     const mimeMatch = arr[0].match(/:(.*?);/);
  //     const mime = mimeMatch ? mimeMatch[1] : "image/png"; // fallback to image/png
  //     const bstr = atob(arr[1]); // decode base64
  //     let n = bstr.length;
  //     const u8arr = new Uint8Array(n);

  //     while (n--) {
  //       u8arr[n] = bstr.charCodeAt(n);
  //     }

  //     const file = new File([u8arr], `${department.department}.png`, {
  //       type: mime,
  //     });

  //     setNewDepartmentIcon(file);
  //   } else {
  //     setNewDepartmentIcon(null);
  //   }
  // };

  const handleEditDepartment = (department) => {
    setDepartmentToEdit(department);
    setNewDepartment(department.department);
    setEditMode(true);

    const matchedDept = medicalDepts?.find(
      (dept) => dept.name.trim() === department.department.trim()
    );

    const base64 = matchedDept?.content;

    if (base64) {
      try {
        let mime = "image/png";
        let base64Data = base64;

        // Check if it’s a proper data URL
        if (base64.startsWith("data:")) {
          const arr = base64.split(",");
          const mimeMatch = arr[0].match(/:(.*?);/);
          mime = mimeMatch ? mimeMatch[1] : "image/png";
          base64Data = arr[1];
        }

        // Decode base64
        const bstr = atob(base64Data);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        const file = new File([u8arr], `${department.department}.png`, {
          type: mime,
        });
        setNewDepartmentIcon(file);
      } catch (error) {
        console.error("Invalid base64 string:", base64);
        toast.error("Failed to load department icon. Invalid image format.");
        setNewDepartmentIcon(null);
      }
    } else {
      setNewDepartmentIcon(null);
    }
  };

  const resetForm = () => {
    setSelectedDepartment("");
    setNewDepartment("");
    setNewDepartmentIcon(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setEditMode(false);
    setDepartmentToEdit(null);
  };
  const departmentsWithIcons = [
    { name: "Sleep Medicine", icon: sleepMedicineIcon },
    { name: "Pain Management", icon: painManagementIcon },
    { name: "Palliative Care", icon: palliativeCareIcon },
    { name: "Internal Medicine", icon: internalMedicineIcon },
    { name: "Family Medicine", icon: familyMedicineIcon },
    { name: "Neonatology", icon: neonatologyIcon },
    { name: "Cardiothoracic Surgery", icon: cardiothoracicSurgeryIcon },
    { name: "Vascular Surgery", icon: vascularSurgeryIcon },
    { name: "Plastic Surgery", icon: plasticSurgeryIcon },
    { name: "Otolaryngology (ENT)", icon: entIcon },
    { name: "Anesthesiology", icon: anesthesiologyIcon },
    { name: "Geriatrics", icon: geriatricsIcon },
    {
      name: "Physical Medicine and Rehabilitation",
      icon: physicalMedicineIcon,
    },
    { name: "Allergy and Immunology", icon: allergyImmunologyIcon },
    { name: "Infectious Diseases", icon: infectiousDiseasesIcon },
    { name: "Rheumatology", icon: rheumatologyIcon },
    { name: "Hematology", icon: hematologyIcon },
    { name: "Radiology", icon: radiologyIcon },
    { name: "Urology", icon: urologyIcon },
    { name: "Orthopaedics", icon: orthopaedicsIcon },
    { name: "Pulmonology", icon: pulmonologyIcon },
    { name: "Emergency Medicines", icon: emergencyMedicinesIcon },
    { name: "Nephrology", icon: nephrologyIcon },
    { name: "Psychiatry", icon: psychiatryIcon },
    { name: "Gynecology", icon: gynecologyIcon },
    { name: "Dermatology", icon: dermatologyIcon },
    { name: "Oncology", icon: oncologyIcon },
    { name: "Neurology", icon: neurologyIcon },
    { name: "Gastroenterology", icon: gastroenterologyIcon },
    { name: "Cardiology", icon: cardiologyIcon },
    { name: "Endocrinology", icon: endocrinologyIcon },
    { name: "Paediatrics", icon: paediatricsIcon },
    { name: "Ophthalmology", icon: ophthalmologyIcon },
    { name: "Dentistry", icon: dentistryIcon },
    { name: "General Practice", icon: generalPracticeIcon },
    { name: "Hepatology", icon: hepatologyIcon },
    { name: "Nutrition", icon: nutritionIcon },
  ];

  const columns = [
    { field: "id", headerName: "ID", width: 150 },
    { field: "department", headerName: "Department Name", width: 270 },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', gap: '16px' }}>
          <IconButton
            size="small"
            aria-label="edit"
            onClick={() => handleEditDepartment(params.row)}
            sx={{
              border: '0.5px solid #0E3F66',
              boxShadow: '0px 1px 5.2px 0px #00000040 inset',
              background: '#EEEEEE'
            }}
          >
            <EDITIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            aria-label="delete"
            onClick={() => handleDeleteDepartment(params.row.department_id)}
            sx={{
              border: '0.5px solid #0E3F66',
              boxShadow: '0px 1px 5.2px 0px #00000040 inset',
              background: '#EEEEEE'
            }}
          >
            <DELETEIcon fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <div className="col-sm-12 col-md-12 col-lg-11.5" style={{ margin: "auto" }}>
      <div className="contact-panel mb-20" style={{ marginTop: "20px" }}>
        <h2 style={{ textAlign: "left", paddingLeft: "11.5px" }}>Departments</h2>
        <Grid container spacing={2} className="department-management-container">
          <Grid item xs={12} md={6}>
            <Box className="department-form-box" style={{ height: "103.4vh" }}>
              <h4 className="department-heading">All Departments</h4>
              <div className="data-grid-container">
                <DataGrid
                  rows={departments}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 10 },
                    },
                  }}
                  pageSizeOptions={[5, 10]}
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "1px solid #e0e0e0",
                      backgroundColor: "#f5f5f5",
                      borderRadius: "4px",
                      fontFamily: "Arial, sans-serif",
                      padding: "5px",
                      maxHeight: "450px",
                      overflow: "auto",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#125386",
                      color: "white",
                      fontSize: "13px",
                      fontWeight: "600",
                      minHeight: "48px !important",
                      "& .MuiDataGrid-columnHeaderTitle": {
                        color: "white",
                        fontWeight: "600",
                        fontSize: "13px",
                      },
                      "& .MuiDataGrid-columnHeader": {
                        borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                        padding: "0 12px",
                      },
                      "& .MuiDataGrid-columnHeader:last-child": {
                        borderRight: "none",
                      },
                      "& .MuiDataGrid-iconButtonContainer": {
                        color: "white",
                      },
                      "& .MuiDataGrid-menuIcon": {
                        color: "white",
                      },
                      "& .MuiDataGrid-sortIcon": {
                        color: "white",
                      },
                      "& .MuiDataGrid-columnHeaderSortable": {
                        "& .MuiDataGrid-sortIcon": {
                          color: "white",
                        },
                      },
                      "& .MuiDataGrid-columnHeaderTitleContainer": {
                        "& .MuiDataGrid-sortIcon": {
                          color: "white",
                        },
                      },
                      "& .MuiSvgIcon-root": {
                        color: "white",
                      },
                    },
                    "& .MuiDataGrid-row": {
                      backgroundColor: "#f5f5f5", // Changed from white to #f5f5f5
                      minHeight: "40px !important",
                      "&:nth-of-type(even)": {
                        backgroundColor: "#f5f5f5", // Changed from white to #f5f5f5
                      },
                      "&:hover": {
                        backgroundColor: "#e8ecef", // Slightly darker shade for hover
                      },
                      "&.Mui-selected": {
                        backgroundColor: "#e3f2fd",
                        "&:hover": {
                          backgroundColor: "#e3f2fd",
                        },
                      },
                      borderBottom: "1px solid #e0e0e0",
                    },
                    "& .MuiDataGrid-cell": {
                      backgroundColor: "#f5f5f5", // Added to ensure cells match row background
                      borderRight: "1px solid #e0e0e0",
                      fontSize: "12px",
                      color: "#374151",
                      padding: "8px 12px",
                      minHeight: "40px !important",
                      "&:last-child": {
                        borderRight: "none",
                      },
                      "&:focus": {
                        outline: "none",
                      },
                    },
                    "& .MuiDataGrid-cellContent": {
                      fontSize: "12px",
                      color: "#374151",
                      fontWeight: "400",
                    },
                    "& .MuiDataGrid-footerContainer": {
                      backgroundColor: "#f8f9fa",
                      borderTop: "1px solid #e0e0e0",
                      minHeight: "52px",
                    },
                    "& .MuiTablePagination-root": {
                      color: "#374151",
                      fontSize: "12px",
                    },
                    "& .MuiDataGrid-toolbarContainer": {
                      backgroundColor: "#f8f9fa",
                      borderBottom: "1px solid #e0e0e0",
                      padding: "8px 16px",
                    },
                  }}
                />
              </div>
            </Box>
          </Grid>


          <Grid item xs={12} md={6}>
            <Box className="department-form-box" style={{ height: "103.4vh" }}>
              <h4 className="department-heading">{editMode ? "Edit Department" : "Add Department"}</h4>

              {!editMode && (
                // <FormControl component="fieldset" className="form-control">
                //   <RadioGroup
                //     row
                //     value={formType}
                //     onChange={handleFormTypeChange}
                //     className="radio-group"
                //   >
                //     <FormControlLabel
                //       value="select"
                //       control={<Radio />}
                //       label="Select Existing Department"
                //     />
                //     <FormControlLabel
                //       value="add"
                //       control={<Radio />}
                //       label="Add New Department"
                //     />
                //   </RadioGroup>
                // </FormControl>
                <FormControl
                  component="fieldset"
                  style={{
                    display: "flex",
                    flexDirection: "row", // Items in a row
                    flexWrap: "wrap", // Wrap to new line on small screens
                    gap: "16px", // Space between radio buttons and autocomplete
                    alignItems: "center", // Vertical alignment
                    // gap:"16px",
                  }}
                >
                  <RadioGroup
                    row
                    value={formType}
                    onChange={handleFormTypeChange}
                    style={{ flex: "1 1 auto", gap: "30px" }} // Ensure proper space usage
                  >
                    <FormControlLabel
                      value="select"
                      control={<Radio />}
                      label="Select Existing Department"
                    />
                    <FormControlLabel
                      value="add"
                      control={<Radio />}
                      label="Add New Department"
                    />
                  </RadioGroup>
                </FormControl>
              )}

              {formType === "select" && !editMode && (
                <FormControl fullWidth style={{ marginBottom: "20px" }}>
                  <StyledAutocomplete
                    options={predefinedDepts}
                    getOptionLabel={(option) => option.name} // Display department name in the dropdown
                    renderOption={(props, option) => (
                      <MenuItem {...props} key={option.name}>
                        {/* <img
                      src={option.icon}
                      alt={option.name}
                      className="department-icon"
                    /> */}
                        {option.name}
                      </MenuItem>
                    )}
                    value={
                      predefinedDepts.find(
                        (dept) => dept.name === selectedDepartment
                      ) || null
                    } // Set the value correctly
                    onChange={(event, newValue) => {
                      setSelectedDepartment(newValue ? newValue.name : ""); // Set department name when selected
                    }}
                    renderInput={(params) => (
                      <StyledTextFieldBootstrap {...params} variant="outlined" />
                    )}
                  />
                </FormControl>
              )}

              {(formType === "add" || editMode) && (
                <>
                  <div className="form-group">
                    <StyledTextFieldBootstrap
                      fullWidth
                      value={newDepartment}
                      onChange={handleNewDepartmentChange}
                    />
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleIconChange}
                      className="file-input"
                      required
                      ref={fileInputRef}
                    />
                  </div>
                </>
              )}

              <div className="button-group" style={{ gap: "0px" }}>
                {editMode && (
                  <button
                    onClick={resetForm}
                    // variant="outlined"
                    // color="secondary"
                    className="cancel-button btn btn__secondary btn__rounded btn__block mt-2"
                    style={{
                      background: '#0E3F66',
                      color: '#FFFFFF',
                      border: '1px solid #0E3F66',
                      borderRadius: '10px',
                      padding: '10px 20px', // Added padding to ensure it fills out like in the image
                      width: '100%', // Ensures it spans the full width like in the image
                      boxSizing: 'border-box', // Ensures padding doesn't affect the width
                      // "&:hover": {
                      //   background: '#125386',
                      //   color: '#FFFFFF',
                      //   border: '1px solid #125386',
                      //   borderRadius: '10px',
                      // }
                    }}
                  >
                    Cancel
                  </button>
                )}
                <button

                  onClick={editMode ? updateDepartment : addDepartmentToFacility}
                  className="submit-button btn btn__secondary btn__rounded btn__block mt-2"
                  style={{
                    background: '#0E3F66',
                    color: '#FFFFFF',
                    border: '1px solid #0E3F66',
                    borderRadius: '10px',
                    padding: '10px 20px', // Added padding to ensure it fills out like in the image
                    width: '100%', // Ensures it spans the full width like in the image
                    boxSizing: 'border-box', // Ensures padding doesn't affect the width
                    // "&:hover": {
                    //   background: '#125386',
                    //   color: '#FFFFFF',
                    //   border: '1px solid #125386',
                    //   borderRadius: '10px',
                    // }
                  }}
                >
                  {editMode ? "Update Department" : "Add Department"}
                </button>
              </div>
            </Box>
          </Grid>
        </Grid >
      </div>
    </div>
  );
}

export default DepartmentManagement;
